export const DEFAULT_SETTINGS = {
    phMin: 7.0, phMax: 7.4,
    clMin: 0.3, clMax: 0.6,
    taMin: 80, taMax: 120,
    filterDays: 30, robotDays: 7, taDays: 7,
    phMinusDose: 100, phMinusEffect: 0.2,
    phPlusDose: 100, phPlusEffect: 0.2,
    clDose: 20, clEffect: 0.1
};
export const AGENTS = {
    phMinus: { label: 'pH-Minus', color: 'var(--ph-minus-color)', badge: 'var(--ph-badge)' },
    phPlus: { label: 'pH-Plus', color: 'var(--ph-plus-color)', badge: 'var(--ph-plus-badge)' },
    chlor: { label: 'Chlor', color: 'var(--cl-agent-color)', badge: 'var(--cl-badge)' }
};
